/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FilterEngineRulesState } from "./type";

const INITIAL_STATE: FilterEngineRulesState = {
  filters: {
    state: "",
    tip: undefined,
    initial_term: undefined,
    final_term: undefined,
    created_at: undefined,
    meta: {
      page: 1,
      perPage: 10,
    },
  },
};

type FilterKeys = keyof FilterEngineRulesState["filters"];

const filterEngineRulesSlice = createSlice({
  name: "filters",
  initialState: INITIAL_STATE,
  reducers: {
    setFilter(state, action: PayloadAction<{ key: FilterKeys; value: any }>) {
      state.filters[action.payload.key] = action.payload.value;
    },
    resetFilters(state) {
      state.filters = INITIAL_STATE.filters;
    },
    setPagination(
      state,
      action: PayloadAction<{ page: number; perPage: number }>
    ) {
      state.filters.meta = action.payload;
    },
  },
});

export const { setFilter, resetFilters, setPagination } =
  filterEngineRulesSlice.actions;
export default filterEngineRulesSlice.reducer;
